<template>
    <div class='box'>
        <phoneCarousel :list="webDate.phoneProductBanner" height="16.25rem" v-if="webDate"></phoneCarousel>
        <div class="product">
            <pageTitle title="饰面设计" subtitle="Decorative Design" titleFontSize="2.43rem" subtitleFontSize="1.22rem">
            </pageTitle>

            <!-- <div class="serch_box">
                <div class="serch_item">
                    <span class="sear_name">产品名称</span>
                    <el-input v-model="query.title" placeholder="请输入" style="width: 30.69rem;" clearable @keyup.enter="getList" />
                </div>
                <div class="serch_item">
                    <span class="sear_name">产品分类</span>
                    <el-cascader v-model="clearIds" placeholder="请选择分类" style="width: 30.69rem;" :options="treeList" :props="{ label: 'name', value: 'id' }" @change='cascChage' clearable>
                    </el-cascader>
                </div>
            </div> -->

            <div class="product_list" v-loading="loading">
                <div class="product_item" v-for="item in list" :key="item.id" @click="handItem(item)">
                    <!-- <img :src="item.cover" class="product_img" alt="">
                    <div class="product_name">{{ item.title }}</div> -->
                    <img :src="item.img" class="product_img" alt="">
                    <div class="product_name">{{ item.name }}</div>
                </div>
            </div>

            <div class="pagination_box">
                <pagination :total="total" v-model:pageNum='query.pageNum' :pagerCount="5" v-model:pageSize='query.pageSize' @currentChange='getList'></pagination>
            </div>

        </div>

        <el-dialog v-model="dialogVisible" width="45.06rem" :show-close="false">
            <div class="dialog_box">
                <div class="title">{{ classItem.name }}</div>
                <div class="img_dia_box">
                    <swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                        <swipe-item v-for="(item, index) in JSON.parse(productList[selProductIndex].detailContent)" :key="index">
                            <img :src="item" class="dia_img" alt="">
                        </swipe-item>
                    </swipe>
                </div>

                <div class="img_list">
                    <div class="img_item" :class="{selImageItem:index===selProductIndex}" v-for="(item,index) in productList" :key="item.id" @click="handProduct(index)">
                        <img :src="item.cover" class="pro_img" alt="">
                        <div class="pro_name">{{item.title}}</div>
                    </div>
                </div>

                <!-- <div class="btn_box">
                    <div class="btn" @click="dialogVisible = false">关闭</div>
                    <div class="btn" @click="downloadFile">下载</div>
                </div> -->
            </div>

        </el-dialog>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import pagination from '@/components/pagination.vue'
import phoneCarousel from "@/components/phoneCarousel.vue"
import pageTitle from '@/components/pageTitle.vue'
import { getTablePage, getTableClass, downPicture, getClassPage } from '@/api/product/index.js'
import { useStore } from 'vuex'
import { Popup } from 'vant';
import html2canvas from 'html2canvas'
import { Swipe, SwipeItem } from 'vant';
const store = useStore()
const webDate = computed(() => store.state.webDate);

const dialogVisible = ref(false);

const list = ref([]);
const query = ref({
    pageNum: 1,
    pageSize: 12,
    title: null,
    catId: null,
})
const total = ref(0);
const loading = ref(false);
const getList = () => {
    loading.value = true;
    // getTablePage(query.value).then(res => {
    //     if (res.code == 0) {
    //         list.value = res.data;
    //         total.value = res.total;
    //     }
    //     loading.value = false;
    // }).catch(err => {
    //     loading.value = false;
    // })

    getClassPage(query.value).then(res => {
        if (res.code == 0) {
            list.value = res.data;
            total.value = res.total;
        }
        loading.value = false;
    }).catch(err => {
        loading.value = false;
    })
}
getList();


const productList = ref([]);
const classItem = ref();
const carouselShow = ref(false);
const handItem = (item) => {
    classItem.value = item;
    // 根据分类id获取商品
    getTablePage({ pageSize: 999, catId: item.id }).then(res => {
        if (res.code == 0) {
            productList.value = res.data;
            dialogVisible.value = true;
            carouselShow.value = true;
        }
    })
}

const selProductIndex = ref(0);
const handProduct = (index) => {
    // console.log(item)
    selProductIndex.value = index;
    carouselShow.value = false;
    setTimeout(() => {
        carouselShow.value = true;
    }, 300)
}

const close = () => {
    selProductIndex.value = 0;
}

const clearIds = ref([]);
const treeList = ref([]);
const getThreeList = () => {
    getTableClass().then(res => {
        if (res.code == 0) {
            let data = threeDate(res.data);
            treeList.value = data;
        }
    })
}
const threeDate = (data) => {
    data.forEach(item => {
        if (item.children && item.children.length > 0) {
            threeDate(item.children);
        } else {
            delete item.children;
        }
    })
    return data;
}
getThreeList();

const cascChage = (e) => {
    if (e && e.length > 0) {
        query.value.catId = e[e.length - 1];
        getList();
    } else {
        query.value.catId = null;
        getList();
    }

}

// 下载
function downloadFile(url) {
    // 设置height和windowwHeight属性，防止只下载当前看到的页面，这样就可以下载完整的内容
    const containerElement = document.querySelector('.img_dia_box')
    html2canvas(containerElement, {
        useCORS: true /*使用跨域*/
    }).then(canvas => {
        // blob
        canvas.toBlob(blob => {
            const href = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = href
            link.download = productItem.value.title + '.png'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }, 'image/png')
    })

}

</script>

<style scoped lang='scss'>
.box {
    padding-top: 6.25rem;

    &:deep(.el-dialog__body) {
        padding: 1.88rem 1.69rem;
    }

    &:deep(.el-dialog__header) {
        display: none;
    }

    &:deep(.el-dialog__footer) {
        display: none;
    }
}

.product {
    padding: 0 1.19rem;
    padding-top: 3.75rem;
    width: 100vw;
    margin: 0 auto;

    .serch_box {
        margin-top: 2.5rem;

        .serch_item {
            display: flex;
            align-items: center;
            margin-bottom: 2.19rem;
            // &::v-deep .el-input__inner {
            //     width: 640px;
            //     height: 75px;
            // }

            .sear_name {
                width: 8rem;
                text-align: right;
                margin-right: 1.5rem;
                font-size: 1.88rem;
            }

            .el_slect {
                width: 30.69rem;
                flex: 1;
            }
        }
    }

    .product_list {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 1.75rem;
        margin-bottom: 3.75rem;
        margin-top: 2.19rem;

        .product_item {
            display: flex;
            flex-direction: column;
            align-items: center;
            align-items: center;

            .product_img {
                width: 21rem;
                height: 15.06rem;
                border-radius: 0.1rem;
            }

            .product_name {
                font-size: 1.88rem;
                color: #000000;
                margin-top: 0.69rem;
                text-align: center;
            }
        }
    }

    .pagination_box {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
    }
}

.dialog_box {
    .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 2.19rem;
        color: #000000;
        margin-bottom: 1.88rem;
    }

    .img_dia_box {
        min-height: 14.06rem;
    }

    .dia_img {
        width: auto;
        height: 24.56rem;
    }

    .img_list {
        display: flex;
        align-items: center;
        width: 43rem;
        overflow-x: scroll;
        margin: 0 auto;
        margin-top: 0.63rem;
        padding-bottom: 0.81rem;
        justify-content: center;

        .img_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 0.63rem;
            padding-bottom: 0.63rem;
            .pro_img {
                width: 11.25rem;
                height: 7.5rem;
            }
            .pro_name {
                margin-top: 0.63rem;
                font-size: 0.94rem;
            }
        }
    }

    .selImageItem {
        // border: .06rem solid #1b5bbb;
        box-shadow: 0.44rem -0.31rem 0.69rem 0.25rem #666666;
    }

    .btn_box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;

        .btn {
            width: 12.25rem;
            height: 5rem;
            border-radius: 0.75rem;
            border: 1px solid #1b5bbb;
            font-size: 1.88rem;
            color: #024d74;
            text-align: center;
            line-height: 5rem;

            &:last-child {
                margin-left: 1.88rem;
                background-color: #1b5bbb;
                color: #ffffff;
            }
        }
    }
}
:deep(.el-dialog) {
    // margin-top: 0.63rem !important;
    border-radius: 0.94rem;

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0.63rem 1.25rem;
    }

    .el-dialog__footer {
        display: none;
    }
}
</style>